export const productTypeOptions = [
  { value: "Vapes,Disposable Pens", label: "Vape Pens" },
  { value: "Vapes,Live Cartridge", label: "Live Carts" },
  { value: "Flower,Flower", label: "Flower" },
  { value: "Flower,Popcorn", label: "Popcorn" },
  { value: "Flower,Shake", label: "Shake" },
  { value: "Prerolls", label: "Pre-Rolls" },
  { value: "Prerolls,Shorties", label: "Shorties" },
  { value: "Concentrates", label: "Concentrates" },
];

export default {
  productTypeOptions,
};
